<template>
  <right-panel :datas="connects" ref="rightPanel" @onClose="onCloseForm">
    <div slot="header">
      <translate>The Aliyun Official Image Which We Support</translate>
    </div>
    <div slot="content" class="wrapper-padding">
      <el-table :data="checkList" style="width: 100%">
        <el-table-column prop="os" :label="attrText.os" width="120"></el-table-column>
        <el-table-column prop="version" :label="attrText.version"></el-table-column>
        <el-table-column :label="attrText.comment">
          <template scope="scope">
            {{ scope.row.comment | translate($gettext)}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="detail-btn">
      <el-button @click="onCloseForm()">
        <translate>Close</translate>
      </el-button>
    </div>
  </right-panel>
</template>

<script>
  import RightPanel from '../../common/right-panel'
  import { ClusterAliyunSupport } from '../../../config'
  export default{
    name: 'ClusterCheckSupport',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null,
        checkList: ClusterAliyunSupport
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    methods: {
      // 提取翻译文本
      getTranslateText () {
        return {
          os: this.$gettext('OS'),
          version: this.$gettext('Version'),
          comment: this.$gettext('Comment')
        }
      },
      onCloseForm () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// cluster-check-support.vue?451e8acd